import React, { useEffect, useState } from "react";
import sportAPI from "../../../api/admin/sportApi";
import { MultiSelect } from "react-multi-select-component";
import mpSportAPI from "../../../api/admin/mpSportApi";
import { showError, showSuccess } from "../../../utils/toastUtils";

function SelectDetails() {
  const [traditionalGameList, setTraditionalGameList] = useState([]);
  const [conventionalGameList, setConventionalGameList] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const [formData, setFormData] = useState({
    traditionalGames: [],
    conventionalGames: [],
  });

  useEffect(() => {
    fetchSportData();
  }, []);

  const fetchSportData = async () => {
    const res = await sportAPI.getAll();
    if (res.code === 200) {
      const traditionalOptions = res?.data?.traditional.map((item) => ({
        label: item.name,
        value: item._id,
      }));

      const conventionalOptions = res?.data?.conventional.map((item) => ({
        label: item.name,
        value: item._id,
      }));

      setTraditionalGameList(traditionalOptions);
      setConventionalGameList(conventionalOptions);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await mpSportAPI.store(formData);
    if (res.code === 200) {
      showSuccess(res.message);
    } else {
      showError(res.message);
    }
  };

  return (
    <form
      method="post"
      onSubmit={handleSubmit}
      className="vh-100 d-flex justify-content-between flex-column"
    >
      <div className="offcanvas-header">
        <h4 id="offcanvasRightLabel">Add Details</h4>
        <button
          type="button"
          id="closeOffcanvasBtn"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>
      <div className="offcanvas-body">
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">
              Traditional Sport <span className="text-danger">*</span>
            </label>
            <span className="text-danger error" id="email_error" />

            <MultiSelect
              options={traditionalGameList}
              value={traditionalGameList.filter((opt) =>
                formData.traditionalGames.includes(opt.value)
              )}
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  traditionalGames: selected.map((s) => s.value),
                }))
              }
              labelledBy="Select Traditional"
            />
            {errors.venue && (
              <span className="invalid-feedback d-block">{errors.venue}</span>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">
              Conventional Sport <span className="text-danger">*</span>
            </label>
            <span className="text-danger error" id="email_error" />
            <MultiSelect
              options={conventionalGameList}
              value={conventionalGameList.filter((opt) =>
                formData.conventionalGames.includes(opt.value)
              )}
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  conventionalGames: selected.map((s) => s.value),
                }))
              }
              labelledBy="Select Conventional"
            />
            {errors.venue && (
              <span className="invalid-feedback d-block">{errors.venue}</span>
            )}
          </div>
        </div>

        <div className="mb-3">
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Storing Data..." : "Submit"}
          </button>
        </div>
      </div>
    </form>
  );
}

export default SelectDetails;
